import { localStorageKey } from '@/constants/localstorage-key'
import { getMemberInformation } from '@/queries/auth/useGetMemberInformationMutation'
import { memberStore } from '@/store/member.store'
import { storyCardTooltipStore } from '@/store/ui/storycard-tooltip.store'

class MemberService {
  public async init() {
    const memberInfo = await getMemberInformation()

    memberStore.getState().changeMemberInfo({
      name: memberInfo.name,
      mdn: memberInfo.mdn,
      memberId: memberInfo.memberId,
      isUnder14: memberInfo.isUnder14,
      memberNo: memberInfo.memberNo,
    })
  }

  public async mainInit() {
    if (this.getAccessToken()) {
      await this.init()
    }
  }

  public async getMemberInit() {
    const memberInfo = await getMemberInformation()

    memberStore.getState().changeMemberInfo({
      name: memberInfo.name,
      mdn: memberInfo.mdn,
      memberId: memberInfo.memberId,
      isUnder14: memberInfo.isUnder14,
      memberNo: memberInfo.memberNo,
    })

    return memberInfo
  }

  public setAccessToken(accessToken: string) {
    if (typeof window === 'undefined') return

    localStorage.setItem(localStorageKey.accessToken, accessToken)
  }

  public getAccessToken(): string | null {
    if (typeof window === 'undefined') return null

    return localStorage.getItem(localStorageKey.accessToken)
  }

  public isLogin(): boolean {
    if (typeof window === 'undefined') return false

    return this.getAccessToken() !== null && !!memberStore.getState().memberId
  }

  public logout() {
    if (typeof window === 'undefined') return

    storyCardTooltipStore.setState({ storyCardTooltipFirstVisibleIdList: [] })
    localStorage.removeItem(localStorageKey.accessToken)
    memberStore.getState().changeMemberInfo({ name: null, mdn: null, memberId: null, isUnder14: null, memberNo: null })
  }
}

export const memberService = new MemberService()
